import React, { useRef, useEffect } from "react";
import {
  I2cInput,
  I2cTooltip,
  I2cSelect,
  I2cMenuItem,
  I2cRadioGroup,
  I2cRadioButton,
  I2cCheckboxGroup,
  I2cRadio,
  I2cListItem,
  I2cAccordion,
  I2cDatePicker,
  I2cIcon,
  I2cCheckbox,
} from "@webcomponents/i2cwebcomponents/dist/react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import usdIcon from "../../../assets/images/USD.svg";
import gbpIcon from "../../../assets/images/GBP.svg";
import pkrIcon from "../../../assets/images/Pkr-flag.svg";
import checkedCheckbox from "../../../assets/images/checked_checkbox.svg";
import uncheckedCheckbox from "../../../assets/images/unchecked_checkbox.svg";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import masterCardParent from "../../../assets/images/Card-icon-parent/mastercard.svg";
import masterCard from "../../../assets/images/Cards-icons/mastercard.svg";
import visaCard from "../../../assets/images/Cards-icons/visa.svg";
import cirrus from "../../../assets/images/Cards-icons/cirrus.svg";
import maestro from "../../../assets/images/Cards-icons/maestro.svg";
import visaPlus from "../../../assets/images/Cards-icons/visa-plus.svg";
import interlink from "../../../assets/images/Cards-icons/interlink.svg";
import blackhawak from "../../../assets/images/Cards-icons/blackhawak.svg";
import cardPlaceholder from "../../../assets/images/card-placeholder.svg";
import discover from "../../../assets/images/Cards-icons/discover.svg";
import americanExpress from "../../../assets/images/Cards-icons/amex.svg";
import unionPay from "../../../assets/images/Cards-icons/unionpay.svg";
import "../Prepaid.scss";
import { cardTechnology, atm_networks, subBin, cardInfo } from "./stringUtils";

const cardNumberOptions = [
  {
    value: "Same Card Number",
    label:
      "Virtual card will be closed when the physical card is received and activated by the consumer.",
  },
  {
    value: "Different Card Numbers",
    label: "Both cards will remain active.",
  },
];

export const cardOptions = [
  {
    label: "Virtual Cards",
    value: "virtual-cards",
    supportText:
      "Only virtual cards will be issued for online transactions. These will not be provisioned to a physical card or payment device.",
  },
  {
    label: "Physical Cards",
    value: "physical-cards",
    supportText: "Account provisioned to a physical card only.",
  },
  {
    label: "Both Virtual and Physical Cards (On Demand)",
    value: "virtual-and-physical-on-demand",
    supportText:
      "Issue a virtual card and initiate the physical card issuance process at the same time.",
  },
  {
    label: "Both Virtual and Physical Cards (Simultaneous Issuance)",
    value: "virtual-and-physical-simultaneous",
    supportText:
      "Issue a virtual card and issue a physical card if requested by the consumer.",
  },
];
const currencies = [
  {
    value: "USD",
    icon: usdIcon,
  },
  {
    value: "GBP",
    icon: gbpIcon,
  },
  {
    value: "PKR",
    icon: pkrIcon,
  },
];
export const binType = [
  { label: "New BIN", value: 0 },
  { label: "Existing BIN", value: 1 },
];

export const binInformation = [
  { label: "BID", value: 0 },
  { label: "ICA", value: 1 },
];
const region = ["US", "Pakistan", "Canada"];

const CardNetwork = ({
  type,
  setAddFormData,
  addFormData,
  setFormValidStates,
  formDataJson,
  isFetching,
}) => {
  const additionalOpt = useRef(null);
  const checkboxRef = useRef(null);

  const handleNetworkCheckboxGroupChange = (event) => {
    let SelectedNetworkValue;
    if (isNaN(event)) SelectedNetworkValue = event.target.value;
    else SelectedNetworkValue = event;
    let updatedSelectedNetworks = [
      ...(methods.getValues("cn_atm_networks") ?? []),
    ];
    if (updatedSelectedNetworks.includes(SelectedNetworkValue)) {
      // If the card is already selected, remove it
      updatedSelectedNetworks = updatedSelectedNetworks.filter(
        (card) => card !== SelectedNetworkValue,
      );
    } else {
      // If the card is not selected, add it
      updatedSelectedNetworks.push(SelectedNetworkValue);
    }
    if (
      updatedSelectedNetworks.includes(5) &&
      methods.watch("cn_atm_networks_other").length
    ) {
      methods.setValue("cn_atm_networks_other", "");
    }
    methods.setValue("cn_atm_networks", updatedSelectedNetworks);
    methods.trigger();
    handleValueChanges();
  };

  const handleCardInfoChange = (event) => {
    let selectedCardInfo;
    if (isNaN(event)) selectedCardInfo = event.target.value;
    else selectedCardInfo = event;
    let updatedSelectedCardsInfo = [
      ...methods.getValues("cn_card_information"),
    ];

    if (updatedSelectedCardsInfo.includes(selectedCardInfo)) {
      // If the card is already selected, remove it
      updatedSelectedCardsInfo = updatedSelectedCardsInfo.filter(
        (card) => card !== selectedCardInfo,
      );
    } else {
      // If the card is not selected, add it
      updatedSelectedCardsInfo.push(selectedCardInfo);
    }
    if (!updatedSelectedCardsInfo.includes(4)) {
      methods.setValue("cn_card_information_other", "");
    }
    methods.setValue("cn_card_information", updatedSelectedCardsInfo);
    methods.trigger();
    handleValueChanges();
  };

  const handleAdditionaInfo = (event) => {
    let selectedCardAdditionalInfo;
    if (isNaN(event)) selectedCardAdditionalInfo = event.target.value;
    else selectedCardAdditionalInfo = event;
    let updatedAdditionalInfo = [
      ...methods.getValues("cn_additional_card_information"),
    ];

    if (updatedAdditionalInfo.includes(selectedCardAdditionalInfo)) {
      // If the card is already selected, remove it
      updatedAdditionalInfo = updatedAdditionalInfo.filter(
        (card) => card !== selectedCardAdditionalInfo,
      );
    } else {
      // If the card is not selected, add it
      updatedAdditionalInfo.push(selectedCardAdditionalInfo);
    }
    if (!updatedAdditionalInfo.includes(4)) {
      methods.setValue("cn_additional_card_information_other", "");
    }
    methods.setValue("cn_additional_card_information", updatedAdditionalInfo);
    methods.trigger();
    handleValueChanges();
  };
  const generalErrorMessage = "Field is required";
  const validationSchema = Yup.object({
    cn_n_networks: Yup.array()
      .required(generalErrorMessage)
      .min(1, generalErrorMessage),
    // cn_n_networks_other: Yup.string().when("cn_n_networks", {
    //   is: (cn_n_networks) => cn_n_networks && cn_n_networks.includes(10),
    //   then: () =>
    //     Yup.string()
    //       .required("Network other is required")
    //       .min(1, "Network other is required."),
    //   otherwise: () => Yup.string().optional(),
    // }),
    cn_atm_networks: Yup.array(Yup.string())
      .required("At least one network must be selected")
      .min(1, "At least one network must be selected"),
    // cn_atm_networks_other: Yup.string().when("cn_atm_networks", {
    //   is: (networks) => networks && networks.includes("5"),
    //   then: () =>
    //     Yup.string()
    //       .required("Network other is required")
    //       .min(1, "Network other is required."),
    //   otherwise: () => Yup.string().optional(),
    // }),
    // cn_bin_Information: Yup.string()
    //   .required(generalErrorMessage)
    //   .min(1, generalErrorMessage),
    cn_n_networks_other: Yup.string().when("cn_n_networks", {
      is: (cn_n_networks) => cn_n_networks && cn_n_networks.includes(10),
      then: () =>
        Yup.string()
          .required("Network other is required")
          .min(1, "Network other is required."),
      otherwise: () => Yup.string().optional(),
    }),
    cn_atm_networks_other: Yup.string().when("cn_atm_networks", {
      is: (networks) => networks && networks.includes("5"),
      then: () =>
        Yup.string()
          .required("Network other is required")
          .min(1, "Network other is required."),
      otherwise: () => Yup.string().optional(),
    }),
    cn_bin_Information: Yup.string()
      .required(generalErrorMessage)
      .min(1, generalErrorMessage),
    cn_business_id: Yup.string()
      .required(generalErrorMessage)
      .min(1, generalErrorMessage),
    cn_bin_no: Yup.string()
      .required(generalErrorMessage)
      .min(1, generalErrorMessage),
    cn_settlement_currency: Yup.array(Yup.string()).optional(),
    cn_bin_quantity: Yup.string()
      .required(generalErrorMessage)
      .min(1, generalErrorMessage),
    cn_bin_quantity_other: Yup.string().when("cn_bin_quantity", {
      is: (cn_bin_quantity) => cn_bin_quantity && cn_bin_quantity === "other",
      then: () =>
        Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    }),
    cn_bin_type: Yup.string()
      .required(generalErrorMessage)
      .min(1, generalErrorMessage),
    cn_target_date: Yup.string().optional(),
    cn_insurance_region: Yup.string().optional(),
    cn_additional_card_information: Yup.array().optional(),
    cn_additional_card_information_other: Yup.string().when(
      "cn_additional_card_information",
      {
        is: (types) => types && types.includes(4),
        then: () =>
          Yup.string().required("Additional option other is required"),
        otherwise: () => Yup.string().optional(),
      },
    ),
    cn_chip_profile: Yup.string()
      .required(generalErrorMessage)
      .min(1, generalErrorMessage),
    cn_card_option: Yup.string()
      .required(generalErrorMessage)
      .min(1, generalErrorMessage),
    cn_card_number: Yup.string().when("cn_card_option", {
      is: (cn_card_option) =>
        [
          "virtual-and-physical-simultaneous",
          "virtual-and-physical-on-demand",
        ].includes(cn_card_option),
      then: () =>
        Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    }),
    cn_card_information: Yup.array().optional(),
    cn_card_information_other: Yup.string().when("cn_card_information", {
      is: (types) => types && types.includes(4),
      then: () => Yup.string().required("Card option other is required"),
      otherwise: () => Yup.string().optional(),
    }),
  });

  // Initialize React Hook Form with Yup resolver
  const methods = useForm({
    resolver: yupResolver(validationSchema),
    mode: "all",
    reValidateMode: "all",
    shouldUseNativeValidation: false,
    criteriaMode: "all",
    defaultValues: {
      cn_n_networks: [],
      cn_n_networks_other: "",
      cn_atm_networks: [],
      cn_atm_networks_other: "",
      cn_bin_Information: "",
      cn_business_id: "",
      cn_bin_no: "",
      cn_settlement_currency: [],
      cn_bin_type: "",
      cn_bin_quantity: "",
      cn_bin_quantity_other: "",
      cn_target_date: "",
      cn_insurance_region: "",
      cn_additional_card_information: [],
      cn_additional_card_information_other: "",
      cn_chip_profile: "",
      cn_card_option: "",
      cn_card_number: "",
      cn_card_information: [],
      cn_card_information_other: "",
    },
  });
  const fields = [
    "cn_n_networks",
    "cn_n_networks_other",
    "cn_atm_networks",
    "cn_atm_networks_other",
    "cn_bin_Information",
    "cn_business_id",
    "cn_bin_no",
    "cn_settlement_currency",
    "cn_bin_type",
    "cn_bin_quantity",
    "cn_bin_quantity_other",
    "cn_target_date",
    "cn_insurance_region",
    "cn_additional_card_information",
    "cn_additional_card_information_other",
    "cn_chip_profile",
    "cn_card_option",
    "cn_card_number",
    "cn_card_information",
    "cn_card_information_other",
  ];

  useEffect(() => {
    if (!isFetching && Object.keys(formDataJson ?? {}).length) {
      fields.forEach((field) => {
        methods.setValue(field, formDataJson[3]["3_0"][field] ?? "");
      });
      methods.trigger();
      handleValueChanges();
    }
  }, [isFetching]);
  // Controlls destructuring from the method
  const {
    control,
    formState: { errors },
  } = methods;

  // Trigger validation when component mounts
  React.useEffect(() => {
    methods.trigger();
  }, []);

  const handleValueChanges = () => {
    const values = methods.getValues();
    setAddFormData({
      ...addFormData,
      3: {
        ...addFormData["3"],
        "3_0": { ...values },
      },
    });
  };

  // Update form validation state when errors change
  React.useEffect(() => {
    const errorsLength = Object.keys(errors)?.length;
    if (errorsLength === 0) setFormValidStates("3_0", true);
    else setFormValidStates("3_0", false);
  }, [Object.keys(errors)?.length]);

  const handleCheckboxGroupChange = (value) => {
    let updatedSelectedNetworks = [
      ...(methods.getValues("cn_n_networks") ?? []),
    ];
    if (updatedSelectedNetworks.includes(value)) {
      // If the card is already selected, remove it
      updatedSelectedNetworks = updatedSelectedNetworks.filter(
        (card) => card !== value,
      );
    } else {
      // If the card is not selected, add it
      updatedSelectedNetworks.push(value);
    }
    if (!updatedSelectedNetworks.includes(10)) {
      methods.setValue("cn_n_networks_other", "");
    }
    methods.setValue("cn_n_networks", updatedSelectedNetworks);
    handleValueChanges();
    methods.trigger();
    if (updatedSelectedNetworks.length) methods.clearErrors("cn_n_networks");
    else
      methods.setError("cn_n_networks", {
        message: "At least one network must be selected",
      });
  };
  const masterCardsSelectedLength = methods
    .watch("cn_n_networks")
    .filter(
      (val) => val === "master-card" || val === "maestro" || val === "cirrus",
    ).length;
  const masterCardIcon =
    masterCardsSelectedLength === 0
      ? uncheckedCheckbox
      : masterCardsSelectedLength > 0 && masterCardsSelectedLength < 3
        ? "linear-minus-square"
        : "cs-linear-check-square";

  const visaCardsSelectedLength = methods
    .watch("cn_n_networks")
    .filter(
      (val) =>
        val === "visa-card" || val === "interlink-card" || val === "plus-card",
    ).length;
  const visaCardIcon =
    visaCardsSelectedLength === 0
      ? "linear-close-square"
      : visaCardsSelectedLength > 0 && visaCardsSelectedLength < 3
        ? "linear-minus-square"
        : "cs-linear-check-square";

  const closedLoopCardsSelectedLength = methods
    .watch("cn_n_networks")
    .filter((val) => val === "blackhawk-networks").length;
  const closedLoopCardIcon =
    closedLoopCardsSelectedLength === 0
      ? "linear-close-square"
      : "cs-linear-check-square";

  return (
    <React.Fragment>
      <div className="forms-instance">
        <div i2c-grid="grid gap-md" className="section-space">
          <div i2c-grid="12">
            <div className="sub-heading">
              Card Networks<sup>•</sup>
            </div>
          </div>
          <div i2c-grid="12">
            <div className="single-field-wrapper">
              <Controller
                name="cn_n_networks"
                control={control}
                render={({ field }) => (
                  <I2cCheckboxGroup
                    className="cardsNetwork"
                    {...field}
                    ref={checkboxRef}
                  >
                    <I2cAccordion
                      summary="MasterCard ®"
                      className={`mb-16 accordion-style${[0, 1, 2].some((value) => methods.watch("cn_n_networks").includes(value)) ? " accordion-style-checked " : ""} `}
                      variant="shadowed"
                      iconStyle=""
                      icon-align="right"
                      style={{ width: "100%" }}
                    >
                      <I2cIcon
                        slot="prefix"
                        src={masterCardParent}
                        style={{ fontSize: "var(--i2c-spacing-11-5)" }}
                        label="icon"
                        className="accord-icon"
                      ></I2cIcon>

                      <span slot="suffix">
                        <I2cIcon
                          src={
                            [0, 1, 2].some((value) =>
                              methods.watch("cn_n_networks").includes(value),
                            )
                              ? checkedCheckbox
                              : uncheckedCheckbox
                          }
                          label="icon"
                          className="accord-toggle"
                        ></I2cIcon>
                      </span>
                      <div i2c-grid="grid gap-sm 3@md" className="pt-16">
                        {[
                          {
                            label: "Mastercard",
                            value: 0,
                            icon: masterCard,
                          },
                          {
                            label: "Cirrus",
                            value: 1,
                            icon: cirrus,
                          },
                          {
                            label: "Maestro",
                            value: 2,
                            icon: maestro,
                          },
                        ].map((card, index) => (
                          <I2cListItem
                            variant="receipt"
                            label={card.label}
                            sublabel=""
                            value=""
                            type="checkbox"
                            key={index}
                            className="card_item_box"
                            checked={methods
                              .watch("cn_n_networks")
                              .includes(card.value)}
                            onI2cCheckboxClicked={(e) =>
                              handleCheckboxGroupChange(card.value)
                            }
                          >
                            <I2cIcon
                              slot="prefix"
                              src={card.icon}
                              style={{ fontSize: "var(--i2c-spacing-8-5)" }}
                              label="icon"
                            ></I2cIcon>
                            <I2cCheckbox
                              slot="prefix"
                              className="customCheckbox"
                              name="cardNetworks"
                              value={card.value}
                              label=""
                              style={{ display: "none" }}
                              ignoreTab
                              // checked={methods
                              //   .watch("cn_n_networks")
                              //   .includes(card.value)}
                            ></I2cCheckbox>
                          </I2cListItem>
                        ))}
                      </div>
                    </I2cAccordion>
                    <I2cAccordion
                      summary="VISA Card ®"
                      className={`mb-16 accordion-style${[3, 4, 5].some((value) => methods.watch("cn_n_networks").includes(value)) ? " accordion-style-checked " : ""}`}
                      variant="shadowed"
                      iconStyle=""
                      icon-align="right"
                      style={{ width: "100%" }}
                    >
                      <I2cIcon
                        slot="prefix"
                        src={visaCard}
                        style={{ fontSize: "var(--i2c-spacing-11-5)" }}
                        label="icon"
                        className="accord-icon"
                      ></I2cIcon>
                      <span slot="suffix">
                        <I2cIcon
                          src={
                            [3, 4, 5].some((value) =>
                              methods.watch("cn_n_networks").includes(value),
                            )
                              ? checkedCheckbox
                              : uncheckedCheckbox
                          }
                          label="icon"
                          className="accord-toggle"
                        ></I2cIcon>
                      </span>
                      <div i2c-grid="grid gap-sm 3@md" className="pt-16">
                        {[
                          {
                            label: "VISA",
                            value: 3,
                            icon: visaCard,
                          },
                          {
                            label: "Interlink",
                            value: 4,
                            icon: interlink,
                          },
                          {
                            label: "PLUS",
                            value: 5,
                            icon: visaPlus,
                          },
                        ].map((card, index) => (
                          <I2cListItem
                            variant="receipt"
                            label={card.label}
                            sublabel=""
                            value=""
                            type="checkbox"
                            key={index}
                            className="card_item_box"
                            checked={methods
                              .watch("cn_n_networks")
                              .includes(card.value)}
                            onI2cCheckboxClicked={(e) =>
                              handleCheckboxGroupChange(card.value)
                            }
                          >
                            <I2cIcon
                              slot="prefix"
                              src={card.icon}
                              style={{ fontSize: "var(--i2c-spacing-8-5)" }}
                              label="icon"
                            ></I2cIcon>
                            <I2cCheckbox
                              slot="prefix"
                              className="customCheckbox"
                              name="cardNetworks"
                              value={card.value}
                              label=""
                              style={{ display: "none" }}
                              ignoreTab
                              // checked={methods
                              //   .watch("cn_n_networks")
                              //   .includes(card.value)}
                            ></I2cCheckbox>
                          </I2cListItem>
                        ))}
                      </div>
                    </I2cAccordion>
                    <I2cListItem
                      variant="receipt"
                      label={"Discover ®"}
                      sublabel=""
                      value=""
                      type="checkbox"
                      key={"discover"}
                      className="cardlist cardlist-custom cardlist-custom-direction"
                      checked={methods.watch("cn_n_networks").includes(6)}
                      onI2cCheckboxClicked={(e) => handleCheckboxGroupChange(6)}
                    >
                      <I2cIcon
                        slot="prefix"
                        src={discover}
                        style={{ fontSize: "var(--i2c-spacing-11-5)" }}
                        label="icon"
                      ></I2cIcon>
                      <span slot="suffix">
                        <I2cIcon
                          src={
                            methods.watch("cn_n_networks").includes(6)
                              ? checkedCheckbox
                              : uncheckedCheckbox
                          }
                          // style={{ fontSize: "var(--i2c-spacing-6-5)" }}
                          label="icon"
                          color="gray"
                          className="accord-toggle"
                        ></I2cIcon>
                      </span>
                      <I2cCheckbox
                        slot="prefix"
                        className="customCheckbox"
                        name="cardNetworks"
                        value={6}
                        label=""
                        style={{ display: "none" }}
                        ignoreTab
                        // checked={methods.watch("cn_n_networks").includes(6)}
                      ></I2cCheckbox>
                    </I2cListItem>
                    <I2cListItem
                      variant="receipt"
                      label={"American Express ®"}
                      sublabel=""
                      value=""
                      type="checkbox"
                      key={"american-express"}
                      className="cardlist cardlist-custom cardlist-custom-direction"
                      checked={methods.watch("cn_n_networks").includes(7)}
                      onI2cCheckboxClicked={(e) => handleCheckboxGroupChange(7)}
                    >
                      <I2cIcon
                        slot="prefix"
                        src={americanExpress}
                        style={{ fontSize: "var(--i2c-spacing-11-5)" }}
                        label="icon"
                      ></I2cIcon>
                      <span slot="suffix">
                        <I2cIcon
                          src={
                            methods.watch("cn_n_networks").includes(7)
                              ? checkedCheckbox
                              : uncheckedCheckbox
                          }
                          // style={{ fontSize: "var(--i2c-spacing-6-5)" }}
                          label="icon"
                          color="gray"
                          className="accord-toggle"
                        ></I2cIcon>
                      </span>
                      <I2cCheckbox
                        slot="prefix"
                        className="customCheckbox"
                        name="cardNetworks"
                        value={7}
                        label=""
                        style={{ display: "none" }}
                        ignoreTab
                        // checked={methods.watch("cn_n_networks").includes(7)}
                      ></I2cCheckbox>
                    </I2cListItem>
                    <I2cListItem
                      variant="receipt"
                      label={"UnionPay ®"}
                      sublabel=""
                      value=""
                      type="checkbox"
                      key={"union-pay"}
                      className="cardlist cardlist-custom cardlist-custom-direction"
                      checked={methods.watch("cn_n_networks").includes(8)}
                      onI2cCheckboxClicked={(e) => handleCheckboxGroupChange(8)}
                    >
                      <I2cIcon
                        slot="prefix"
                        src={unionPay}
                        style={{ fontSize: "var(--i2c-spacing-11-5)" }}
                        label="icon"
                      ></I2cIcon>
                      <span slot="suffix">
                        <I2cIcon
                          src={
                            methods.watch("cn_n_networks").includes(8)
                              ? checkedCheckbox
                              : uncheckedCheckbox
                          }
                          // style={{ fontSize: "var(--i2c-spacing-6-5)" }}
                          label="icon"
                          color="gray"
                          className="accord-toggle"
                        ></I2cIcon>
                      </span>
                      <I2cCheckbox
                        slot="prefix"
                        className="customCheckbox"
                        name="cardNetworks"
                        value={8}
                        label=""
                        style={{ display: "none" }}
                        ignoreTab
                        // checked={methods.watch("cn_n_networks").includes(8)}
                      ></I2cCheckbox>
                    </I2cListItem>
                    <I2cAccordion
                      summary="Closed Loop ®"
                      className={`mb-16 accordion-style ${[9].some((value) => methods.watch("cn_n_networks").includes(value)) ? " accordion-style-checked " : ""}`}
                      variant="shadowed"
                      iconStyle=""
                      icon-align="right"
                      style={{ width: "100%" }}
                    >
                      <I2cIcon
                        slot="prefix"
                        src={cardPlaceholder}
                        style={{ fontSize: "var(--i2c-spacing-11-5)" }}
                        label="icon"
                        className="accord-icon"
                      ></I2cIcon>
                      <span slot="suffix">
                        <I2cIcon
                          src={
                            [9].some((value) =>
                              methods.watch("cn_n_networks").includes(value),
                            )
                              ? checkedCheckbox
                              : uncheckedCheckbox
                          }
                          label="icon"
                          className="accord-toggle"
                        ></I2cIcon>
                      </span>
                      <div i2c-grid="grid gap-sm 3@md" className="pt-16">
                        {[
                          {
                            label: "Blackhawk Network",
                            value: 9,
                            icon: blackhawak,
                          },
                        ].map((card, index) => (
                          <I2cListItem
                            variant="receipt"
                            label={card.label}
                            sublabel=""
                            value=""
                            type="checkbox"
                            key={index}
                            className="card_item_box"
                            checked={methods
                              .watch("cn_n_networks")
                              .includes(card.value)}
                            onI2cCheckboxClicked={(e) =>
                              handleCheckboxGroupChange(card.value)
                            }
                          >
                            <I2cIcon
                              slot="prefix"
                              src={card.icon}
                              style={{ fontSize: "var(--i2c-spacing-8-5)" }}
                              label="icon"
                            ></I2cIcon>
                            <I2cCheckbox
                              slot="prefix"
                              className="customCheckbox"
                              name="cardNetworks"
                              value={card.value}
                              label=""
                              style={{ display: "none" }}
                              ignoreTab
                              // checked={methods
                              //   .watch("cn_n_networks")
                              //   .includes(card.value)}
                            ></I2cCheckbox>
                          </I2cListItem>
                        ))}
                      </div>
                    </I2cAccordion>
                    <I2cListItem
                      variant="receipt"
                      label={"Other"}
                      sublabel=""
                      value=""
                      type="checkbox"
                      key={"other"}
                      className="cardlist cardlist-custom cardlist-custom-direction"
                      checked={methods.watch("cn_n_networks").includes(10)}
                      onI2cCheckboxClicked={(e) =>
                        handleCheckboxGroupChange(10)
                      }
                    >
                      <I2cIcon
                        slot="prefix"
                        src={cardPlaceholder}
                        style={{ fontSize: "var(--i2c-spacing-11-5)" }}
                        label="icon"
                      ></I2cIcon>
                      <span slot="suffix">
                        <I2cIcon
                          src={
                            methods.watch("cn_n_networks").includes(10)
                              ? checkedCheckbox
                              : uncheckedCheckbox
                          }
                          label="icon"
                          color="gray"
                          className="accord-toggle"
                        ></I2cIcon>
                      </span>
                      <I2cCheckbox
                        slot="prefix"
                        className="customCheckbox"
                        name="cardNetworks"
                        value={10}
                        label=""
                        style={{ display: "none" }}
                        ignoreTab
                        // checked={methods.watch("cn_n_networks").includes(10)}
                      ></I2cCheckbox>
                    </I2cListItem>
                  </I2cCheckboxGroup>
                )}
              />
            </div>
            {methods.watch("cn_n_networks").includes(10) && (
              <div i2c-grid="grid" className="single-field-wrapper mt-16">
                <div i2c-grid="6@md">
                  <Controller
                    name="cn_n_networks_other"
                    control={control}
                    render={({ field }) => (
                      <I2cInput
                        {...field}
                        name={"cn_n_networks_other"}
                        className="single-input-field"
                        placeholder="Please Specify"
                        onI2cInput={(e) => {
                          const value = e.target.value;
                          field.onChange(value);
                          handleValueChanges();
                          if (value.length === 0) {
                            methods.setError("cn_n_networks_other", {
                              message: "Network other is required.",
                            });
                          } else {
                          }
                        }}
                        required={errors.cn_n_networks_other ? true : false}
                        size="large"
                        label="Please Specify"
                      />
                    )}
                  />
                  {/* <ErrorMessage
                    show={
                      errors.cn_n_networks_other &&
                      methods.formState.touchedFields.cn_n_networks_other
                        ? true
                        : false
                    }
                    message={
                      errors.cn_n_networks_other?.message ?? "Invalid input"
                    }
                  /> */}
                </div>
              </div>
            )}
          </div>
        </div>
        <div i2c-grid="grid gap-md" className="section-space">
          <div i2c-grid="12">
            <div className="sub-heading mb-4">
              ATM Networks<sup>•</sup>
            </div>
            <div className="custom-label-light">
              Select the networks that you have an existing relationship with.
            </div>
          </div>
          <div i2c-grid="12">
            <div className="single-field-wrapper">
              <Controller
                name="cn_atm_networks"
                control={control}
                render={({ field }) => (
                  <>
                    <I2cCheckboxGroup
                      {...field}
                      className="centeredCheckbox checkbox-margin"
                    >
                      <div i2c-grid="grid gap-sm">
                        {atm_networks.map((card, index) => (
                          <I2cListItem
                            key={index}
                            i2c-grid="4@md"
                            variant="receipt"
                            label={card.label}
                            sublabel=""
                            value=""
                            type="checkbox"
                            checked={methods
                              .watch("cn_atm_networks")
                              .includes(card.value)}
                            onI2cCheckboxClicked={(e) => {
                              handleNetworkCheckboxGroupChange(card.value);
                            }}
                          >
                            <I2cIcon
                              slot="prefix"
                              src={card.icon}
                              style={{ fontSize: "var(--i2c-spacing-11-5)" }}
                              label="icon"
                            ></I2cIcon>
                            <I2cCheckbox
                              slot="checkbox"
                              name="atmNetwork"
                              filled
                              value={card.value}
                              label=""
                              ignoreTab
                              checked={methods
                                .watch("cn_atm_networks")
                                .includes(card.value)}
                         
                              className="customCheckbox"
                            ></I2cCheckbox>
                          </I2cListItem>
                        ))}
                      </div>
                    </I2cCheckboxGroup>
                    <ErrorMessage
                      show={
                        errors.cn_atm_networks &&
                        methods.formState.touchedFields.cn_atm_networks
                          ? true
                          : false
                      }
                      message={
                        errors.cn_atm_networks?.message ?? "Invalid input"
                      }
                    />
                  </>
                )}
              />
            </div>
            {methods.watch("cn_atm_networks").includes(5) && (
              <>
                <div
                  i2c-grid="grid 6@md"
                  className="mt-16 single-field-wrapper"
                >
                  <Controller
                    name="cn_atm_networks_other"
                    control={control}
                    render={({ field }) => (
                      <I2cInput
                        {...field}
                        name={"cn_atm_networks_other"}
                        className="single-input-field"
                        placeholder="Please Specify"
                        onI2cInput={(e) => {
                          const value = e.target.value;
                          field.onChange(value);
                          handleValueChanges();
                          if (value.length === 0) {
                            methods.setError("cn_atm_networks_other", {
                              message: "Network other is required.",
                            });
                          } else {
                          }
                        }}
                        required={errors.cn_atm_networks_other ? true : false}
                        size="large"
                        label="Please Specify"
                      />
                    )}
                  />
                </div>
                {/* <ErrorMessage
                  show={
                    errors.cn_atm_networks_other &&
                    methods.formState.touchedFields.cn_atm_networks_other
                      ? true
                      : false
                  }
                  message={
                    errors.cn_atm_networks_other?.message ?? "Invalid input"
                  }
                /> */}
              </>
            )}
          </div>
        </div>
        <div i2c-grid="grid gap-md" className="section-space">
          <div i2c-grid="12">
            <div className="sub-heading">
              BIN Information<sup>•</sup>
            </div>
            <div className="custom-label-light">
              Do you have any specific BIN information?
            </div>
          </div>
          <div i2c-grid="12">
            <I2cRadioGroup
              required
              onI2cChange={(e) => {
                methods.clearErrors("cn_bin_Information");
                methods.setValue("cn_bin_Information", e.target.value);
                handleValueChanges();
              }}
            >
              {binInformation.map((bin, index) => (
                <I2cRadioButton
                  key={index}
                  name="cn_bin_Information"
                  value={bin.value}
                  label={bin.label}
                  checked={methods.watch("cn_bin_Information") === bin.value}
                >
                  {bin.label}
                </I2cRadioButton>
              ))}
            </I2cRadioGroup>
          </div>
          <div i2c-grid="12">
            <div i2c-grid="grid gap-column-sm gap-row-md">
              <div i2c-grid="6@md">
                <div className="single-field-wrapper">
                  <Controller
                    name="cn_business_id"
                    control={control}
                    render={({ field }) => (
                      <I2cInput
                        {...field}
                        name={"cn_business_id"}
                        className={"single-input-field"}
                        placeholder="Enter Business ID"
                        onI2cInput={(e) => {
                          const value = e.target.value;
                          field.onChange(value);
                          handleValueChanges();
                          if (value.length === 0) {
                            methods.setError("cn_business_id", {
                              message: "Network other is required.",
                            });
                          } else {
                          }
                        }}
                        invalid={errors.cn_business_id ? true : false}
                        required={true}
                        size="large"
                        label="Business ID"
                      >
                        <I2cTooltip
                          slot="suffix"
                          hoist
                          content="Issued by the network. ICA (MasterCard only), BID (Visa only)."
                          placement="right-start"
                        >
                          <I2cIcon name="cs-linear-help-circle"></I2cIcon>
                        </I2cTooltip>
                      </I2cInput>
                    )}
                  />
                  {/* <ErrorMessage
                    show={
                      errors.cn_business_id &&
                      methods.formState.touchedFields.cn_business_id
                        ? true
                        : false
                    }
                    message={errors.cn_business_id?.message ?? "Invalid input"}
                  /> */}
                </div>
              </div>
              <div i2c-grid="6@md">
                <div className="single-field-wrapper">
                  <Controller
                    name="cn_bin_no"
                    control={control}
                    render={({ field }) => (
                      <I2cInput
                        {...field}
                        name={"cn_bin_no"}
                        className={"single-input-field"}
                        placeholder="Enter BIN(s)"
                        onI2cInput={(e) => {
                          const value = e.target.value;
                          field.onChange(value);
                          handleValueChanges();
                          if (value.length === 0) {
                            methods.setError("cn_bin_no", {
                              message: "Network other is required.",
                            });
                          } else {
                          }
                        }}
                        invalid={errors.cn_bin_no ? true : false}
                        size="large"
                        label="BIN(s)"
                        required
                      >
                        <I2cTooltip
                          slot="suffix"
                          hoist
                          content="The 6-8 Digit Bank Identification Number assigned by the network to
										support card issuance."
                          placement="right-start"
                        >
                          <I2cIcon name="cs-linear-help-circle"></I2cIcon>
                        </I2cTooltip>
                      </I2cInput>
                    )}
                  />
                  {/* <ErrorMessage
                    show={
                      errors.cn_bin_no &&
                      methods.formState.touchedFields.cn_bin_no
                        ? true
                        : false
                    }
                    message={errors.cn_bin_no?.message ?? "Invalid input"}
                  /> */}
                </div>
              </div>
              <div i2c-grid="6@md">
                <div className="single-field-wrapper">
                  <I2cSelect
                    label="Settlement Currency"
                    onI2cChange={(e) => {
                      const existingVal = methods.getValues(
                        "cn_settlement_currency",
                      );
                      if (e?.target?.value.length !== existingVal?.length) {
                        methods.setValue(
                          "cn_settlement_currency",
                          e.target.value,
                        );
                      }
                      if (e.target.value)
                        methods.clearErrors("cn_settlement_currency");
                      handleValueChanges();
                    }}
                    className={"single-input-field"}
                    value={methods.watch("cn_settlement_currency")}
                    placeholder="Select Currencies"
                    size="large"
                    multiple
                    helpText=""
                  >
                    {currencies.map((currency, index) => (
                      <I2cMenuItem key={index} value={currency.value}>
                        <i2c-avatar
                          image={currency.icon}
                          part="avatars"
                          label={currency.value}
                        ></i2c-avatar>
                        {currency.value}
                      </I2cMenuItem>
                    ))}
                  </I2cSelect>
                  <ErrorMessage
                    show={
                      errors.cn_settlement_currency &&
                      methods.formState.touchedFields.cn_settlement_currency
                        ? true
                        : false
                    }
                    message={
                      errors.cn_settlement_currency?.message ?? "Invalid input"
                    }
                  />
                </div>
              </div>
              <div i2c-grid="6@md">
                <div slot="label" className="organize-tooltip mb-6">
                  <div className="custom-label-light">
                    Type of BIN<sup>•</sup>&nbsp;
                  </div>
                  <I2cTooltip
                    content="Select ‘Existing BIN’ if you have already setup card programs for
							this BIN"
                    placement="right-start"
                  >
                    <I2cIcon label="placement" name="cs-linear-info"></I2cIcon>
                  </I2cTooltip>
                </div>
                <I2cRadioGroup
                  onI2cChange={(e) => {
                    methods.clearErrors("cn_bin_type");
                    methods.setValue("cn_bin_type", e.target.value);
                    handleValueChanges();
                  }}
                >
                  {binType.map((bin, index) => (
                    <I2cRadioButton
                      key={index}
                      size="medium"
                      name="bi_binType"
                      value={bin.value}
                      label={bin.label}
                      checked={methods.watch("cn_bin_type") === bin.value}
                    >
                      {bin.label}
                    </I2cRadioButton>
                  ))}
                </I2cRadioGroup>
              </div>
            </div>
          </div>

          <div i2c-grid="12">
            <div slot="label" className="organize-tooltip mb-8">
              <div className="custom-label">
                {" "}
                Number of Sub-BINs desired<sup>•</sup>&nbsp;
              </div>
              {/* <I2cTooltip content="" placement="right-start">
                <I2cIcon label="placement" name="cs-linear-info"></I2cIcon>
              </I2cTooltip> */}
            </div>
            <I2cRadioGroup
              onI2cChange={(e) => {
                const value = e.target.value;
                if (value !== "other")
                  methods.setValue("cn_bin_quantity_other", "");
                methods.setValue("cn_bin_quantity", value);
                methods.trigger();
                handleValueChanges();
              }}
            >
              <div i2c-grid="grid gap-sm">
                {subBin.map((bin, index) => (
                  <I2cListItem
                    key={index}
                    i2c-grid="4@md"
                    variant="receipt"
                    label={bin.label}
                    sublabel=""
                    value=" "
                    type="checkbox"
                    checked={methods.watch("cn_bin_quantity") === bin.value}
                  >
                    <I2cRadio
                      slot="prefix"
                      filled
                      name="cn_bin_quantity"
                      value={bin.value}
                      checked={methods.watch("cn_bin_quantity") === bin.value}
                      className="customCheckbox"
                    >
                      {" "}
                    </I2cRadio>
                  </I2cListItem>
                ))}
              </div>
            </I2cRadioGroup>
            {methods.watch("cn_bin_quantity") === "other" && (
              <div i2c-grid="grid 4@md" className="mt-16">
                <div className="single-field-wrapper">
                  <Controller
                    name="cn_bin_quantity_other"
                    control={control}
                    render={({ field }) => (
                      <I2cInput
                        {...field}
                        type="number"
                        required
                        className={"single-input-field"}
                        placeholder="Other Details"
                        onI2cInput={(e) => {
                          const value = e.target.value;
                          field.onChange(value);
                          handleValueChanges();
                        }}
                        size="large"
                        label="Enter Details"
                        name={"cn_bin_quantity_other"}
                      />
                    )}
                  />
                  {/* <ErrorMessage
                    show={
                      errors.cn_bin_quantity_other &&
                      methods.formState.touchedFields.cn_bin_quantity_other
                        ? true
                        : false
                    }
                    message={
                      errors.cn_bin_quantity_other?.message ?? "Invalid input"
                    }
                  /> */}
                </div>
              </div>
            )}
          </div>

          <div i2c-grid="12">
            <div i2c-grid="grid">
              <div i2c-grid="6@md">
                <div className="single-field-wrapper">
                  <Controller
                    name="cn_target_date"
                    control={control}
                    render={({ field }) => (
                      <>
                        <I2cDatePicker
                          {...field}
                          name="cn_target_date"
                          onI2cDateApply={(e) => {
                            if (e.target?.appliedDate)
                              field.onChange(
                                e.target?.appliedDate[0]?.toDateString() ?? "",
                              );
                            else field.onChange("");
                            handleValueChanges();
                          }}
                          invalid={errors.cn_target_date ? true : false}
                          value={methods.watch("cn_target_date")}
                          I2cDatePicker
                          dateFormat="d-m-Y"
                          label="Target Install/Migration Date"
                          size="large"
                          defaultDate={
                            methods.watch("cn_target_date")
                              ? new Date(methods.watch("cn_target_date"))
                              : ""
                          }
                        />
                        <span slot="label"></span>
                      </>
                    )}
                  />
                  <ErrorMessage
                    show={
                      errors.cn_target_date &&
                      methods.formState.touchedFields.cn_target_date
                        ? true
                        : false
                    }
                    message={errors.cn_target_date?.message ?? "Invalid input"}
                  />
                </div>
              </div>
              <div i2c-grid="6@md">
                <div className="single-field-wrapper" i2c-grid="6@md">
                  <Controller
                    name="cn_insurance_region"
                    control={control}
                    render={({ field }) => (
                      <I2cSelect
                        {...field}
                        name="cn_insurance_region"
                        onI2cChange={(e) => {
                          methods.setValue(
                            "cn_insurance_region",
                            e.target.value,
                          );
                          if (e.target.value)
                            methods.clearErrors("cn_insurance_region");
                          handleValueChanges();
                        }}
                        required={errors.cn_insurance_region ? true : false}
                        className={"single-input-field"}
                        label="Issuance Country/Region(s)"
                        value={methods.watch("cn_insurance_region")}
                        placeholder="Select Issuance Country/Region(s)"
                        size="large"
                        helpText=""
                      >
                        {region.map((country, index) => (
                          <I2cMenuItem key={index} value={country}>
                            {country}
                          </I2cMenuItem>
                        ))}
                      </I2cSelect>
                    )}
                  />
                  <ErrorMessage
                    show={
                      errors.cn_insurance_region &&
                      methods.formState.touchedFields.cn_insurance_region
                        ? true
                        : false
                    }
                    message={
                      errors.cn_insurance_region?.message ?? "Invalid input"
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          <div i2c-grid="12">
            <span slot="label" className="organize-tooltip mb-16">
              {type !== "credit" ? (
                <div className="custom-label">Additional Options&nbsp;</div>
              ) : (
                <div className="custom-label"> Card Technology&nbsp;</div>
              )}

              <I2cTooltip
                content="Magstripe, EMV Chip & PIN – contact or contactless
							chip in addition to magnetic stripe for enhanced security. Contactless – conduct contactless payment
							transactions"
                placement="right-start"
                hoist
              >
                <I2cIcon label="placement" name="cs-linear-info"></I2cIcon>
              </I2cTooltip>
            </span>
            <I2cCheckboxGroup
              name="cn_additional_card_information"
              ref={additionalOpt}
            >
              <div i2c-grid="grid gap-sm">
                {cardTechnology.map((card, index) => (
                  <div key={index} i2c-grid="4@md">
                    <I2cListItem
                      variant="receipt"
                      label={card.label}
                      sublabel=""
                      value=""
                      type="checkbox"
                      checked={methods
                        .watch("cn_additional_card_information")
                        .includes(card.value)}
                      onI2cCheckboxClicked={(e) =>
                        handleAdditionaInfo(card.value)
                      }
                    >
                      <I2cCheckbox
                        slot="prefix"
                        name="co_infoShare"
                        value={card.value}
                        filled
                        label=""
                        ignoreTab
                        checked={methods
                          .watch("cn_additional_card_information")
                          .includes(card.value)}
                        // onI2cChange={(e) => handleAdditionaInfo(e)}
                        className="customCheckbox"
                      ></I2cCheckbox>
                    </I2cListItem>
                  </div>
                ))}
              </div>
            </I2cCheckboxGroup>
            {methods.watch("cn_additional_card_information").includes(4) && (
              <div i2c-grid="grid 6@md" className={"mt-16"}>
                <div className="single-field-wrapper">
                  <Controller
                    name="cn_additional_card_information_other"
                    control={control}
                    render={({ field }) => (
                      <I2cInput
                        {...field}
                        className={"single-input-field"}
                        required
                        // className={style.halfWidth + " single-input-field"}
                        placeholder="Please Specify"
                        onI2cInput={(e) => {
                          const value = e.target.value;
                          field.onChange(value);
                          handleValueChanges();
                        }}
                        invalid={
                          errors.cn_additional_card_information_other
                            ? true
                            : false
                        }
                        size="large"
                        label="Enter Details"
                        name={"cn_additional_card_information_other"}
                      />
                    )}
                  />
                  {/* <ErrorMessage
                    show={
                      errors.cn_additional_card_information_other &&
                      methods.formState.touchedFields
                        .cn_additional_card_information_other
                        ? true
                        : false
                    }
                    message={
                      errors.cn_additional_card_information_other?.message ??
                      "Invalid input"
                    }
                  /> */}
                </div>
              </div>
            )}
          </div>
          <div i2c-grid="6@md">
            <div className="single-field-wrapper">
              <Controller
                name="cn_chip_profile"
                control={control}
                render={({ field }) => (
                  <I2cInput
                    {...field}
                    className={"single-input-field"}
                    placeholder=""
                    onI2cInput={(e) => {
                      const value = e.target.value;
                      field.onChange(value);
                      handleValueChanges();
                    }}
                    invalid={errors.cn_chip_profile ? true : false}
                    size="large"
                    label="Chip Profile"
                    name={"cn_chip_profile"}
                    required
                  >
                    <I2cTooltip
                      slot="suffix"
                      hoist
                      content="Please confirm the chip profile recommended by the Network"
                      placement="right-start"
                    >
                      <I2cIcon name="cs-linear-help-circle"></I2cIcon>
                    </I2cTooltip>
                  </I2cInput>
                )}
              />
              {/* <ErrorMessage
                show={
                  errors.cn_chip_profile &&
                  methods.formState.touchedFields.cn_chip_profile
                    ? true
                    : false
                }
                message={errors.cn_chip_profile?.message ?? "Invalid input"}
              /> */}
            </div>
          </div>
        </div>
        <div i2c-grid="grid gap-md" className="section-space">
          <div i2c-grid="12">
            <div className="sub-heading mb-4">
              Card Options<sup>•</sup>
            </div>
            <div className="custom-label-light mb-24">
              Please confirm the card options for this card program.
            </div>
            <I2cRadioGroup
              name="cn_card_option"
              onI2cChange={(e) => {
                const value = e.target.value ?? "";
                methods.setValue("cn_card_option", value);
                if (value === "virtual-cards" || value === "physical-cards") {
                  methods.setValue("cn_card_number", "");
                }
                methods.trigger();
                handleValueChanges();
                // methods.clearErrors("cn_card_option");
                // if (
                //   [
                //     "virtual-and-physical-on-demand",
                //     "virtual-and-physical-simultaneous",
                //   ].includes(value)
                // ) {
                //   if (!methods.getValues("cn_card_number").length)
                //     methods.setError("cn_card_number", {
                //       message: generalErrorMessage,
                //     });
                // } else {
                //   methods.setValue("cn_card_number", "");
                //   methods.clearErrors("cn_card_number");
                // }
              }}
            >
              <div i2c-grid="grid gap-sm">
                {cardOptions.map((option, index) => (
                  <I2cListItem
                    key={index}
                    i2c-grid="6@md"
                    variant="receipt"
                    label={option.label}
                    style={{ display: "flex", justifyContent: "space-between" }}
                    sublabel=""
                    className="option-container cardlist-custom-direction"
                    checked={
                      methods.getValues("cn_card_option") === option.value
                    }
                    type="checkbox"
                  >
                    <I2cRadio
                      slot="prefix"
                      filled
                      checked={
                        methods.getValues("cn_card_option") === option.value
                      }
                      name="cardOption"
                      value={option.value}
                    ></I2cRadio>
                    <I2cTooltip
                      slot="suffix"
                      hoist
                      content={option.supportText}
                      placement="right-start"
                    >
                      <I2cIcon
                        color="#8e99aa"
                        name="cs-linear-help-circle"
                      ></I2cIcon>
                    </I2cTooltip>
                  </I2cListItem>
                ))}
              </div>
            </I2cRadioGroup>
          </div>
          {(methods.watch("cn_card_option") ===
            "virtual-and-physical-simultaneous" ||
            methods.watch("cn_card_option") ===
              "virtual-and-physical-on-demand") && (
            <div i2c-grid="12">
              <div className="sub-heading">
                Card Number<sup>•</sup>
              </div>
              <div className="custom-label-light mb-16">
                If both Virtual and Physical cards are to be issued, will they
                have:
              </div>
              <I2cRadioGroup
                onI2cChange={(e) => {
                  const value = e.target.value ?? "";
                  methods.setValue("cn_card_number", value);
                  handleValueChanges();
                  methods.clearErrors("cn_card_number");
                }}
              >
                <div i2c-grid="grid">
                  {cardNumberOptions.map((option, index) => (
                    <I2cListItem
                      key={index}
                      i2c-grid="6@md"
                      variant="receipt"
                      label={option.value}
                      sublabel=""
                      className="option-container cardlist-custom-direction "
                      checked={
                        methods.getValues("cn_card_number") === option.value
                      }
                      type="checkbox"
                    >
                      <I2cRadio
                        slot="prefix"
                        filled
                        value={option.value}
                        checked={
                          methods.getValues("cn_card_number") === option.value
                        }
                      ></I2cRadio>
                      <I2cTooltip
                        slot="suffix"
                        hoist
                        content={option.label}
                        placement="right-start"
                      >
                        <I2cIcon
                          color="#8e99aa"
                          name="cs-linear-help-circle"
                        ></I2cIcon>
                      </I2cTooltip>
                    </I2cListItem>
                  ))}
                </div>
              </I2cRadioGroup>
            </div>
          )}
          <div i2c-grid="12">
            <div className="sub-heading mb-4">Card Information</div>
            <div className="custom-label-light mb-16">
              How will the virtual card information be shared with the
              cardholders?
            </div>
            <I2cCheckboxGroup name="cn_card_information" ref={checkboxRef}>
              <div i2c-grid="grid gap-sm">
                {cardInfo.map((card, index) => (
                  <div key={index} i2c-grid="6@md">
                    <I2cListItem
                      variant="receipt"
                      label={card.label}
                      sublabel=""
                      value=""
                      type="checkbox"
                      checked={methods
                        .watch("cn_card_information")
                        .includes(card.value)}
                      onI2cCheckboxClicked={(e) =>
                        handleCardInfoChange(card.value)
                      }
                    >
                      <I2cCheckbox
                        slot="prefix"
                        value={card.value}
                        label=""
                        ignoreTab
                        filled
                        checked={methods
                          .watch("cn_card_information")
                          .includes(card.value)}
                        // onI2cChange={(e) => handleCardInfoChange(e)}
                        className="customCheckbox"
                      ></I2cCheckbox>
                    </I2cListItem>
                  </div>
                ))}
              </div>
            </I2cCheckboxGroup>
          </div>
          {methods.watch("cn_card_information").includes(4) && (
            <div i2c-grid="6@sm">
              <div className="single-field-wrapper">
                <Controller
                  name="cn_card_information_other"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      required
                      className={"single-input-field"}
                      placeholder="Other Details"
                      onI2cInput={(e) => {
                        const value = e.target.value;
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      invalid={errors.cn_card_information_other ? true : false}
                      size="large"
                      label="Enter Details"
                      name={"cn_card_information_other"}
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.cn_card_information_other &&
                    methods.formState.touchedFields.cn_card_information_other
                      ? true
                      : false
                  }
                  message={
                    errors.cn_card_information_other?.message ?? "Invalid input"
                  }
                /> */}
              </div>
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default CardNetwork;
